import { useEffect, useState, useCallback } from "react";
import customerService from "@/services/customerService";

export default function useCampaignCustomers(branchId) {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sending, setSending] = useState(false);

  const fetchCustomers = useCallback(async () => {
    setLoading(true);
    try {
      const res = await customerService.getCampaignCustomers({
        offset: 0,
        limit: 50,
        branchId: branchId || undefined,
      });

      const rows = Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res?.data)
        ? res.data
        : [];

      setCustomers(rows);
    } catch (err) {
      console.error("FAILED TO FETCH CAMPAIGN CUSTOMERS:", err);
      setCustomers([]);
    } finally {
      setLoading(false);
    }
  }, [branchId]);

  const sendCampaign = useCallback(async (data) => {
    setSending(true);
    try {
      const res = await customerService.sendCampaign(data);
      return res;
    } catch (err) {
      console.error("FAILED TO SEND CAMPAIGN:", err);
      throw err;
    } finally {
      setSending(false);
    }
  }, []);

  useEffect(() => {
    fetchCustomers();
  }, [fetchCustomers]);

  return {
    customers,
    loading,
    sending,
    refetch: fetchCustomers,
    sendCampaign,
  };
}